.container {
  background-color: #17171b;
  text-align: center;
  flex: 1;
  position: relative;
  box-sizing: border-box;
  overflow: hidden;
  border-radius: 0.375rem;
  display: flex;
  justify-content: center;
  height: 100%;
  flex-direction: column;
}

.image-container {
  position: relative;
  width: 100%;
  height: 100%;
  max-width: 100%;
  max-height: 100%;
}

.image-layout {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
}

.icon-box {
  cursor: pointer;
}

.image-controller {
  display: flex;
  justify-content: end;
  width: 100%;
  height: 4rem;
  min-height: 4rem;
  background-color: var(--bg-color-dark-black);
  align-items: center;
  padding: 0 1.6rem;
  border-radius: 0 0 0.4rem 0.4rem;
}

.moodboard-card-picture {
  text-align: center;
  user-select: none;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  min-height: 0;

  img {
    width: 100%;
    height: 100%;
    user-select: none;
    object-fit: contain;
  }
}

.replacement-image {
  height: 53rem;
  width: 53rem;
  font-family: Inter, sans-serif;
  font-size: 1.6rem;
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--white-default);
  background-color: var(--color-grey-3);
  margin: auto;

  p {
    text-transform: uppercase;
    font-weight: 600;
  }
}
